import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { siteConfig } from "@/config/site";
import { Metadata } from "next";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function constructMetadata({
  title = siteConfig.name,
  description = siteConfig.description,
  image = siteConfig.ogImage,
  icons = "/favicon.ico",
  noIndex = false,
}: {
  title?: string;
  description?: string;
  image?: string;
  icons?: string;
  noIndex?: boolean;
} = {}): Metadata {
  return {
    title,
    description,
    keywords: [
      "quicknhs",
      "quicknhs.com",
      "NHS jobs",
      "UK NHS jobs",
      "UK health jobs",
      "healthcare careers",
      "job tracker",
      "job notifications",
      "job search",
      "NHS job alerts",
      "healthcare job dashboard",
      "medical jobs UK",
      "NHS careers",
      "health job postings",
      "career move healthcare",
    ],
    authors: [
      {
        name: "advertalyst private limited",
        url: "https://quicknhs.com",
      },
    ],
    creator: "Advertalyst Private Limited",
    openGraph: {
      type: "website",
      locale: "en_US",
      url: siteConfig.url,
      title,
      description,
      siteName: title,
    },
    twitter: {
      card: "summary_large_image",
      title,
      description,
      images: [image],
      creator: "@advertalyst_ai",
    },
    icons,
    metadataBase: new URL(siteConfig.url),
    manifest: "/site.webmanifest",
    ...(noIndex && {
      robots: {
        index: false,
        follow: false,
      },
    }),
  };
}
